<div *ngIf="ownerId && isInited" class="right-actions">
  <div #sectionsPanel class="right-actions__sections p-panel" [style.min-width]="fixedPanelMinWidth">
    <div class="p-panel-header">
      <span class="p-panel-title">Bereiche</span>
    </div>

    <div class="right-actions__sections__list">
      <p-listbox
        *ngIf="!(isLoading$ | async)"
        [listStyle]="{ height: '100%' }"
        [options]="sections$ | async"
        [(ngModel)]="selectedSection"
        (onChange)="sectionSelected($event)"
        [style]="{ height: '100%' }"
      >
        <ng-template let-area let-i="index" pTemplate="item">
          <div class="p-helper-clearfix">
            <span [ngClass]="{ 'has-selected-nodes': area.value.hasSelectedNodes }">{{ area.value.key }}</span>
          </div>
        </ng-template>
      </p-listbox>

      <skeleton-preloader-list-component
        *ngIf="isLoading$ | async"
        [entities]="getSkeletonSectionsArray()"
      ></skeleton-preloader-list-component>
    </div>
  </div>

  <div class="right-actions__tree-panel">
    <p-panel styleClass="right-actions__tree-panel__panel">
      <p-header>
        <span class="p-panel-title">Berechtigte Aktionen</span>

        <!-- Header Controls Container -->
        <div class="header-controls">
          <div class="filter-container">
            <div class="p-input-icon-left p-input-icon-right">
              <i [class]="filterValue ? 'pi pi-filter-fill' : 'pi pi-filter'"></i>
              <input
                #filterInput
                type="text"
                pInputText
                placeholder="Aktionen filtern..."
                [(ngModel)]="filterValue"
                (input)="onFilterInput($event)"
                class="filter-input"
              />
              <i
                *ngIf="filterValue"
                class="pi pi-times clear-filter-icon"
                (click)="clearFilter()"
                pTooltip="Filter löschen"
              ></i>
            </div>
          </div>
        </div>
      </p-header>
    </p-panel>

    <p-treeTable
      #treeTable
      *ngIf="treeTableData$ | async as treeTableData"
      class="right-actions__tree-panel__tree"
      [ngClass]="{ 'sticky-header': stickyTableHeader }"
      [value]="getCurrentSectionEntities(treeTableData)"
      [columns]="actionColumns"
      (onNodeExpand)="nodeExpanded($event)"
      (onNodeCollapse)="nodeCollapsed($event)"
      [loading]="false"
      [scrollable]="false"
      [style]="{ border: 'unset', 'pointer-events': (disableEditing$ | async) ? 'none' : 'all' }"
    >
      <!-- Header Template -->
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns; let i = index">
            <span *ngIf="!col.action" [innerHTML]="col.header"></span>

            <icon-action-button
              *ngIf="col.action"
              [icon]="getIconClass(col.action)"
              [tooltip]="col.tooltip || ''"
              [tooltipEnabled]="!!col.tooltip"
              [tooltipPosition]="'bottom'"
              [hoverEnabled]="false"
            >
            </icon-action-button>
          </th>
        </tr>
      </ng-template>

      <!-- Body Template with Dynamic Actions support -->
      <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
        <tr>
          <td *ngFor="let col of columns; let i = index">
            <ng-container *ngIf="i === 0">
              <ng-container *ngIf="!(isLoading$ | async)">
                <div class="checkbox-container">
                  <span
                    *ngIf="hasNonStandardActions(rowNode.node) && !isRootLevelDynamicAction(rowNode.node)"
                    class="p-treetable-toggler p-link"
                    [ngClass]="{ 'p-treetable-toggler-expanded': rowNode.expanded }"
                    (click)="toggleDynamicActions(rowNode)"
                  >
                    <i
                      class="p-treetable-toggler-icon pi pi-fw"
                      [ngClass]="rowNode.expanded ? 'pi-chevron-down' : 'pi-chevron-right'"
                    ></i>
                  </span>

                  <!-- Only show tree table toggler for entities that are NOT root-level dynamic actions -->
                  <p-treeTableToggler
                    *ngIf="!hasNonStandardActions(rowNode.node) || isRootLevelDynamicAction(rowNode.node)"
                    [rowNode]="rowNode"
                  >
                  </p-treeTableToggler>

                  <p-checkbox
                    [binary]="true"
                    [ngModel]="isEntitySelected(rowNode.node)"
                    (onChange)="onEntityToggle(rowNode.node, $event)"
                    [ngClass]="{ 'indeterminate-checkbox': isEntityIndeterminate(rowNode.node) }"
                    [ngStyle]="{ 'vertical-align': 'middle' }"
                  >
                  </p-checkbox>

                  <span [ngStyle]="{ 'margin-left': '8px' }">{{ rowNode.node.name }}</span>
                </div>
              </ng-container>

              <skeleton-preloader-tile-component *ngIf="isLoading$ | async"></skeleton-preloader-tile-component>
            </ng-container>

            <!-- STANDARD: Action Columns -->
            <ng-container *ngIf="i > 0 && col.action">
              <!-- Show skeleton if loading, otherwise real content -->
              <p-checkbox
                *ngIf="!(isLoading$ | async) && hasStandardAction(rowNode.node, col.action)"
                [binary]="true"
                [ngModel]="isActionSelected(rowNode.node, col.action)"
                (onChange)="onActionToggle(rowNode.node, col.action, $event)"
                [ngStyle]="{ 'vertical-align': 'middle' }"
              >
              </p-checkbox>

              <skeleton-preloader-tile-component *ngIf="isLoading$ | async"></skeleton-preloader-tile-component>
            </ng-container>
          </td>
        </tr>

        <!-- Only show dynamic actions row for entities that are NOT root-level dynamic actions -->
        <tr
          *ngIf="rowNode.expanded && hasNonStandardActions(rowNode.node) && !isRootLevelDynamicAction(rowNode.node)"
          class="dynamic-actions-row"
        >
          <td [attr.colspan]="columns.length" class="dynamic-actions-cell">
            <div class="dynamic-actions-container">
              <div *ngFor="let action of getDynamicActions(rowNode.node)" class="dynamic-action-item">
                <!-- indentation structure -->
                <span class="dynamic-action-indent"></span>

                <p-checkbox
                  [binary]="true"
                  [ngModel]="isActionSelected(rowNode.node, action)"
                  (onChange)="onActionToggle(rowNode.node, action, $event)"
                  class="dynamic-action-checkbox"
                >
                </p-checkbox>

                <label class="dynamic-action-label">{{ action }}</label>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="actionColumns.length" class="text-center p-3">
            <i class="pi pi-search" style="font-size: 2rem; color: var(--text-color-secondary)"></i>
            <div style="margin-top: 1rem; color: var(--text-color-secondary)">
              Keine passenden Aktionen für "{{ filterValue }}" gefunden.
            </div>
          </td>
        </tr>
      </ng-template>
    </p-treeTable>
  </div>
</div>
